import type { PostContentObjectDetail, PostContentObjectList } from 'models';
import { useMutation } from 'query';
import { deletePost } from '../../services';
import { getContentObjectId } from '../../utils';
import { useContentObjectCache } from '../cache';

type DeletePostContentObject = { contentObject: PostContentObjectDetail | PostContentObjectList };

export const useDeletePostContentObjectMutation = () => {
  const cache = useContentObjectCache();

  return useMutation<DeletePostContentObject, DeletePostContentObject>({
    async mutationFn(object) {
      await deletePost({ routeParams: { id: getContentObjectId(object.contentObject) } });

      return object;
    },
    onSuccess(_data, { contentObject }) {
      cache.remove(contentObject);
    },
  });
};
